import { Datatype } from '../../../../expressions/datatype/Datatype';
import {
  IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference';
import { IReferencePath } from '../../../../expressions/references/IReferencePath';
import { IAsyncValueWidget } from './IAsyncValueWidget';

export function getAsyncValueWidgetReference(
  path: IReferencePath,
  widget: IAsyncValueWidget,
): IReference {
  return {
    type: ReferenceType.Widget,
    path,
    id: widget.id,
    code: widget.code,
    label: widget.code,
    field: {
      // Il valore è sempre una stringa, come per le async select
      type: Datatype.String,
    },
  };
}
